import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-Lamp",
  "use": "svg-icon-Lamp-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-Lamp\"><path d=\"M4.29 8.59V7.47C3.12 6.774 2 5.462 2 4a4 4 0 1 1 8 0c0 1.452-1.132 2.732-2.29 3.433v1.156H4.29zM4.3 9.7h3.4v.767a1.5 1.5 0 0 1-1.5 1.5h-.4a1.5 1.5 0 0 1-1.5-1.5V9.7z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol